import type {
  ClientType,
  ReferralTypeValue,
} from '@/common/hooks/referrals/types';

const baseBrokerageFields = {
  city: '',
  companyName: '',
  email: '',
  licenseNumber: '',
  phone: '',
  cellPhone: '',
  state: '',
  street1: '',
  street2: '',
  taxId: '',
  zip: '',
  mlsCode: '',
  officeEmail: '',
};

const baseContactFields = {
  id: undefined as string | undefined,
  cellPhone: '',
  email: '',
  firstName: '',
  lastName: '',
  state: '',
};

export const baseAgentFields = {
  ...baseContactFields,
  googleContactId: null as string | null,
  licenseNumber: '',
  licenseState: '',
  teamId: '',
  userId: '',
  brokerage: {
    ...baseBrokerageFields,
  },
  broker: {
    firstName: '',
    lastName: '',
    licenseNumber: '',
    cellPhone: '',
    email: '',
  },
  supervisingBroker: {
    firstName: '',
    lastName: '',
    licenseNumber: '',
    cellPhone: '',
    email: '',
  },
  isSideAgent: false,
};

export const defaultValues = {
  id: '',
  client: {
    ...baseContactFields,
    notes: '',
    clientTypesList: [] as ClientType[],
    city: '',
    street1: '',
    street2: '',
    zip: '',
  },
  referralType: 'sending' as ReferralTypeValue,
  referringAgent: {
    ...baseAgentFields,
  },
  transactingAgent: {
    ...baseAgentFields,
  },
  notes: '',
};

export type AgentFields = typeof baseAgentFields;

/**
 * NewReferral seeds the form from `defaultValues`, but ReferralOverview's
 * EditView mounts the same components against a fetched `Referral`, whose
 * agents are optional — and a save can write `undefined` back over either of
 * them. The agents are widened here so consumers can't assume a presence the
 * runtime form doesn't guarantee.
 */
export type FieldValues = Omit<
  typeof defaultValues,
  'referringAgent' | 'transactingAgent'
> & {
  referringAgent?: AgentFields;
  transactingAgent?: AgentFields;
};
